module.exports = __webpack_public_path__ + "img/8.72285216.png";